import useGetMLInferredRole from 'bundles/onboarding-common/hooks/useGetMLInferredRole';
import useOccupationPreferencesData from 'bundles/onboarding-common/hooks/useOccupationPreferencesData';
import type { RoleFragment } from 'bundles/onboarding-common/queries/__generated__/RoleFragment';

type UseGetDefaultInferredRoleReturn = {
  inferredRole: Pick<RoleFragment, 'id' | 'name'> | undefined;
  inferredRoleLoading: boolean;
};

const useGetDefaultInferredRole = ({ skip }: { skip: boolean }): UseGetDefaultInferredRoleReturn => {
  const { value: userSavedRoles, loading: userSavedRolesLoading } = useOccupationPreferencesData({
    skip,
  });
  const hasUserSavedRoles = !userSavedRolesLoading && !!userSavedRoles && userSavedRoles.length > 0;
  const skipInferredRoleQueries = skip || userSavedRolesLoading || hasUserSavedRoles;

  const { mlInferredRole, mlInferredRoleLoading } = useGetMLInferredRole({ skip: skipInferredRoleQueries });

  return {
    inferredRole: mlInferredRole,
    inferredRoleLoading: userSavedRolesLoading || mlInferredRoleLoading,
  };
};

export default useGetDefaultInferredRole;
